import { render } from "./ResourcesContainer.vue?vue&type=template&id=a89dd092"
import script from "./ResourcesContainer.vue?vue&type=script&lang=js"
export * from "./ResourcesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__